export enum CacheKeys {
  ME = 'me',
  LOCATION = 'location',
  LOCATIONS = 'locations',
  SIGNATURE = 'locations',
  PEDESTAL = 'pedestal',
  RECEIPT = 'receipt',
  RECEIPTS = 'receipts',
  PAYMENT_ORDER = 'paymentOrder',
  PAYMENT_ORDERS = 'paymentOrders',
  SESSION_GROUP = 'sessionGroup',
  SESSION_REQUEST = 'sessionRequest',
  EMPLOYEES = 'employees',
  ACTIVE_AUTHORIZATION = 'activeAuthorization',
  SAVED_CARDS = 'savedCards',
}
